import EmployeeService from '../services/employees.service';



const state = {
	total: 0,
	employees: [],
	employeesPage: [],
	newEmployee: null,
	notAllowedError: false,
	sellers:[],
	employeesNoLinkedIds:[],
	totalNoLinkeds: 0,

	columns: [
		{
			key: 'id',
			label: 'Id',
			visible: true,
			changebale: false
		},

		{
			key: 'departmentName',
			label: 'Departments',
			'class': 'td-30',
			visible: true,
			changebale: true
		},
		{
			key: 'address',
			label: 'Address',
			visible: true,
			changebale: true
		},
		{
			key: 'citizenName',
			label: 'Citizen',
			visible: true,
			changebale: true
		},
		{
			key: 'phone',
			label: 'Phone',
			visible: true,
			changebale: true
		},
		{
			key: 'fullName',
			label: 'Full name',
			sortable: true,
			visible: true,
			changebale: true
		},
		{
			key: 'dateOfBirth',
			label: 'employees.date-of-birth',
			sortable: true,
			visible: true,
			changebale: true
		},
		{
			key: 'gender',
			label: 'Gender',
			sortable: true,
			visible: true,
			changebale: true
		},
		{
			key: 'email',
			label: 'Email',
			sortable: true,
			visible: false,
			changebale: true
		},
		{
			key: 'actions',
			label: 'Actions',
			'class': 'table_actions',
			visible: true,
			changebale: false
		}

	],
	createEmployeeErrorMessage: '',
	createError: false,


}

const getters = {

	getemployees: (state) => {
		return state.employees
	},
	total: (state) => {
		return state.total;
	},
	columns: (state) => {
		return state.columns
	},
	getPagination: (state) => {
		return state.employeesPage;
	},
	getSellers(state){
		return state.sellers;
	}
}

const actions = {
	async getEmployeNoLinkedId({commit}, data) {
		try {
			let res = await EmployeeService.getByNoLinkedId(data);
			commit('setEmployeNoLinkedId' ,res.data);
			return true;
		} catch (e) {
			return false;
		}
	},
	async getAllSellers({commit}, keyword) {
		try {
			const sellers = await EmployeeService.getSellers(keyword);
			commit('setSellers', sellers.data);
			return true;
		} catch (e) {
			return false;
		}
s	},
	async getDepartmentByEmployeeList({commit}, payload) { // payloadda nima bervoriladi page bn limit shuni bermadizku qayta zaprosda

		try {
			const getDepByEmployee = await EmployeeService.byDepartment(payload);
			commit('setGetEmployee', getDepByEmployee.data);
			return true;

		} catch (e) {
			return false;
		}
	},

	async createEmployee({commit}, payloadEmployee) {
		try {
			const employee = await EmployeeService.saveEmployee(payloadEmployee);
			commit('newEmployee', employee.data);
			return true;
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('createEmployeeError', {message: response.message, boolean: true});
			return false;
		}

	},
	async deleteEmployeeStore({commit}, employeeId) {

		try {
			const employeeRes = await EmployeeService.deleteEmployee(employeeId)
			commit('deleteEmoloyee', {employeeRes, employeeId});
			return true;
		} catch (e) {
			return false;
		}

	},
	async getEmployeePagination({commit}, data) {
		try {
			const employeePage = await EmployeeService.search(data);
			commit('setGetEmployee', employeePage.data);
			return true;
		} catch (e) {
			return false;
		}
	}

}

const mutations = {
	setEmployeNoLinkedId(state, payload) {
		state.totalNoLinkeds = payload.total
		state.employeesNoLinkedIds = payload.items
	},
	setSellers(state,sellers){
		state.sellers = sellers
	},
	setGetEmployee(state, res) {
		state.employees = res;
		state.total = res.total;

	},
	newEmployee(state, addedEmployee) {
		state.newEmployee = addedEmployee;
	},

	deleteEmoloyee(state, payload) {
		if (payload.employeeRes) {
			let foundIndex = state.employees.findIndex(x => x.id == payload.id);
			state.employees.splice(foundIndex, 1);
			state.notAllowedError = false;
		}
	},
	createEmployeeError(state, payload) {
		state.createError = payload.boolean;
		state.createEmployeeErrorMessage = payload.message;

	}


}
export const employees = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}

